import {Button, DatePicker, Form, Select} from "antd";
import React, {useState} from "react";
import moment from "moment/moment";

export const FacilityBenchmarkFilters = (props) => {

    const [year_range, setYearRange] = useState([]);
    const [category, setCategory] = useState([]);
    const [region, setRegion] = useState([]);
    const [city, setCity] = useState([]);
    const [state, setState] = useState([]);
    const [country, setCountry] = useState([]);
    const [climate_zone, setClimate_zone] = useState([]);
    const [company, setCompany] = useState('CurrentCompany');

    const formRef = React.useRef()

    function handleYearRange(value) {
        setYearRange(value)
    }

    function handleCategory(category) {
        setCategory(category)
    }

    function handleRegion(region) {
        setRegion(region)
    }

    function handleCity(city) {
        setCity(city)
    }

    function handleState(state) {
        setState(state)
    }

    function handleCountry(country) {
        setCountry(country)
    }

    function handleClimate_zone(climate_zone) {
        setClimate_zone(climate_zone)
    }

    function handleCompany(company) {
        setCompany(company)
    }



    const yearRangeFilter = () => {
        return (
            <DatePicker.RangePicker 
                placeholder={['Start Year', 'End Year']}
                value={year_range}
                onChange={handleYearRange} 
                picker="year"
                style={{ width: '100%' }}
            />
        )
    }

    const categoryFilter = () => {
        return (
            <Select
                mode="multiple"
                allowClear
                value={category}
                style={{
                    width: '100%',
                }}
                getPopupContainer={trigger => trigger.parentNode}
                placeholder="Category"
                onChange={handleCategory}
                options={props.category_options}
            />
        )
    }
    const regionFilter = () => {
        return <Select
            mode="multiple"
            allowClear
            value={region}
            style={{
                width: '100%',
            }}
            getPopupContainer={trigger => trigger.parentNode}
            placeholder="Region"
            onChange={handleRegion}
            options={props.region_options}
        />
    }

    const cityFilter = () => {
        return <Select
            mode="multiple"
            allowClear
            value={city}
            style={{
                width: '100%',
            }}
            getPopupContainer={trigger => trigger.parentNode}
            placeholder="City"
            onChange={handleCity}
            options={props.city_options}
        />
    }

    const stateFilter = () => {
        return <Select
            mode="multiple"
            allowClear
            value={state}
            style={{
                width: '100%',
            }}
            getPopupContainer={trigger => trigger.parentNode}
            placeholder="State"
            onChange={handleState}
            options={props.state_options}
        />
    }

    const countryFilter = () => {
        return <Select
            mode="multiple"
            allowClear
            value={country}
            style={{
                width: '100%',
            }}
            getPopupContainer={trigger => trigger.parentNode}
            placeholder="Country"
            onChange={handleCountry}
            options={props.country_options}
        />
    }

    const climateZoneFilter = () => {
        return <Select
            mode="multiple"
            allowClear
            value={climate_zone}
            style={{
                width: '100%',
            }}
            getPopupContainer={trigger => trigger.parentNode}
            placeholder="Climate Zone"
            onChange={handleClimate_zone}
            options={props.climate_zone_options}
        />
    }

    const companyFilter = () => {
        return <Select
            mode="single"
            allowClear
            value={company}
            style={{
                width: '100%',
            }}
            getPopupContainer={trigger => trigger.parentNode}
            placeholder="Company"
            onChange={handleCompany}
            options={props.company_options}
        />
    }

    function handleSubmit(e) {
        props.handleFilter(e)
    }

    const handleValuesChange = (_, e) => {
        props.handleFilter(e)
    }

    return <Form
        id="myForm"
        layout="horizontal"
        onFinish={handleSubmit}
        ref={formRef}
        onValuesChange={handleValuesChange}
    >
        {/* <Form.Item name={'company'} className={'md:w-60 lg:w-60 sm:w-full'}>
            {companyFilter()}
        </Form.Item> */}

        <Form.Item name={'year_range'} className={'md:w-80 lg:w-80 sm:w-full'}>
            {yearRangeFilter()}
        </Form.Item>

        <Form.Item name={'region'} className={'md:w-60 lg:w-60 sm:w-full'}>
            {regionFilter()}
        </Form.Item>

        <Form.Item name={'city'} className={'md:w-60 lg:w-60 sm:w-full'}>
            {cityFilter()}
        </Form.Item>

        <Form.Item name={'state'} className={'md:w-60 lg:w-60 sm:w-full'}>
            {stateFilter()}
        </Form.Item>

        <Form.Item name={'country'} className={'md:w-60 lg:w-60 sm:w-full'}>
            {countryFilter()}
        </Form.Item>

        <Form.Item name={'category'} className={'md:w-60 lg:w-60 sm:w-full'}>
            {categoryFilter()}
        </Form.Item>

        <Form.Item name={'climate_zone'} className={'md:w-60 lg:w-60 sm:w-full'}>
            {climateZoneFilter()}
        </Form.Item>

        {/* <Form.Item>
            <Button type="primary" htmlType="submit">Submit</Button>
        </Form.Item> */}
    </Form>

}
